import React from "react";
import { Link } from "react-router-dom";

const AdsBannerTop = () => {
  return (
    // <Link
    //   to={"https://luvvella.com"}
    //   target="_blank"
    //   className="padding flex flex-col"
    // >
    //   <div className="sm:h-[30vh] h-[23vh] w-full relative flex items-center justify-center">
    //     <img
    //       src="/banner1.jpg"
    //       alt="banner"
    //       className=" w-full h-full object-cover rounded-t-[10px]"
    //     />

    //     <h1 className="absolute fancy-text-overlay md:text-[6rem] sm:text-[4rem] text-[2.8rem] font-[600]">
    //       Luvvella
    //     </h1>
    //   </div>

    //   <div className="bg-dark shadow-lg h-full border border-gray rounded-b-[10px] text-center p-[5px]">
    //     <Link
    //       to={"https://luvvella.com"}
    //       target="_blank"
    //       className="text-red font-[600] mont sm:text-[20px] text-[18px] cursor-pointer"
    //     >
    //       luvvella.com
    //     </Link>
    //     <br />{" "}
    //     <p className="sans sm:text-[17px] text-[15px] text-white font-[500]">
    //       ✨ Find Your Spark on Luvvella! 💖 Discover connections that matter.
    //       Your soulmate could be one click away. Join now! 💌
    //     </p>
    //   </div>
    // </Link>

    <div></div>
  );
};

export default AdsBannerTop;
